import Button from "@metacrm/metacrm-material-ui/dist/Button";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { StyledWhiteContainer } from "../settings/common.styles";
import moment from "moment";
import CardPopMenu from "./components/CardPopMenu";
import useNavigateEntity from "hooks/useNavigateEntity";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useOutletContext } from "react-router";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { Loading } from "features/common";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import { useIntl } from "react-intl";
import { formatDate } from "features/helpers/utils";
import useGetPagePermission from "hooks/useGetPagePermission";

export default function KolGroups() {
  const { navigateEntity } = useNavigateEntity();
  const { formatMessage } = useIntl();
  const [data, setData] = useState([]);
  const [entityName] = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const dispatchSnackbar = useDispatchSnackbar();
  const confirm = useConfirm();

  const pagePermission = useGetPagePermission();
  // const { canEdit } = pagePermission("kolGroups");
  const canEdit = true;

  async function getKolGroupsData() {
    try {
      setIsLoading(true);
      // const { data } = await axios(`${apiUrl}/api/kol/${entityName}/kolGroups`);

      const data = [
        {
          _id: "6710bfa0e2fb266c6d5d3573",
          entity: "659e2421a68ca1205a0faafa",
          name: "EthanX5111",
          created: "2024-10-17T07:41:20.616Z",
          updated: "2024-11-27T07:18:14.697Z",
          __v: 2,
          kols: [
            "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
            "https://pbs.twimg.com/profile_images/1841377109794557952/uNPzewap_normal.jpg",
            "https://pbs.twimg.com/profile_images/1841377109794557952/uNPzewap_normal.jpg",
          ],
        },
        {
          _id: "6710cdeca7aac4775de033e5",
          entity: "659e2421a68ca1205a0faafa",
          name: "EthanX6",
          created: "2024-10-17T08:42:20.037Z",
          updated: "2024-11-27T07:31:40.577Z",
          __v: 6,
          endDate: "2024-10-14T08:42:20.037+00:00",
          kols: [
            "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
            "https://pbs.twimg.com/profile_images/1688868602437394432/GJBf9glE_normal.jpg",
          ],
        },
        {
          _id: "6717196928af1b49deef0a91",
          entity: "659e2421a68ca1205a0faafa",
          name: "test react hook",
          created: "2024-10-22T03:18:01.672Z",
          updated: "2024-11-12T10:32:02.193Z",
          __v: 0,
          kols: [
            "https://pbs.twimg.com/profile_images/1810478548957933568/7VD3yNDK_normal.jpg",
          ],
        },
        {
          _id: "67176f9f27b4cc64758c5e76",
          entity: "659e2421a68ca1205a0faafa",
          name: "Ethan1022",
          created: "2024-10-22T09:25:51.323Z",
          updated: "2024-10-22T09:42:32.951Z",
          __v: 0,
          kols: [
            "https://pbs.twimg.com/profile_images/874276197357596672/kUuht00m_normal.jpg",
          ],
        },
      ];

      setData(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getKolGroupsData();
  }, []);

  async function deleteKolGroupsData(groupId) {
    try {
      confirm({
        title: formatMessage({ id: "kolGroup.deleteGroup.title" }),
        content: formatMessage({ id: "kolGroup.deleteGroup.description" }),
        confirmText: formatMessage({ id: "popup.confirmToDelete" }),
        cancelText: formatMessage({ id: "popup.confirmCancel" }),
      })
        .then(async () => {
          await axios.delete(
            `${apiUrl}/api/kol/${entityName}/kolGroups/${groupId}`
          );
          await getKolGroupsData();
          dispatchSnackbar({ message: "Delete Success", variant: "success" });
        })
        .catch(() => {});
    } catch (err) {
      dispatchSnackbar({ err });
    }
  }

  return (
    <div>
      <Loading open={isLoading} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          mb: "24px",
          flexWrap: "wrap",
        }}
        className="fade-up"
      >
        <div>
          <div className="title">
            {formatMessage({ id: "kolGroups.title" })}
          </div>
          <div className="description">
            {formatMessage({
              id: "kolGroups.subtitle",
            })}
          </div>
        </div>
      </Box>
      <Grid container spacing={1} className="fade-up-more" key={data?.length}>
        {data.map((item, index) => {
          const { _id, name, description, kols, updated } = item;
          return (
            <Grid
              item
              key={index}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              onClick={() => navigateEntity(`/kol/kolGroups/${_id}`)}
            >
              <StyledWhiteContainer
                key={index}
                sx={{
                  marginBottom: "0px",
                  cursor: "pointer",
                  padding: "20px",
                  width: "100%",
                  position: "relative",
                  height: "170px",
                  ":hover": {
                    border: "1px solid #7B61FF",
                  },
                }}
              >
                {canEdit && (
                  <Box position="absolute" top="12px" right="8px">
                    <CardPopMenu
                      handleDelete={() => deleteKolGroupsData(_id)}
                      groupId={_id}
                    />
                  </Box>
                )}
                <Box
                  mb="4px"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box fontSize={12} color="#777">
                    {formatMessage({
                      id: "kolGroup.card.name",
                    })}
                  </Box>
                </Box>
                <Box
                  fontSize={14}
                  color="#555"
                  fontWeight={700}
                  className="truncate"
                  mb="16px"
                >
                  {name}
                </Box>

                <Box mb="8px" color="#777" fontSize={12}>
                  {formatMessage({
                    id: "kolGroup.card.kol",
                  })}
                </Box>
                <Box display="flex" alignItems="center" flexWrap="wrap">
                  {kols.slice(0, 5)?.map((link, index) => (
                    <Box
                      component="img"
                      src={link}
                      key={index}
                      width={24}
                      height={24}
                      borderRadius="50%"
                      sx={{
                        ml: index !== 0 ? "-4px" : 0,
                        objectFit: "cover",
                        border: "2px solid #FFF",
                      }}
                    />
                  ))}
                  <Box ml="4px" whiteSpace="nowrap">
                    {kols?.length > 0
                      ? `${kols.length} ${formatMessage({
                          id: "kolGroup.card.kol",
                        })}`
                      : "-"}
                  </Box>
                </Box>

                <Box fontSize={10} color="#A5A5A5" mt="24px">
                  {formatMessage({ id: "global.header.lastUpdated" })}
                  {": "}
                  {formatDate(updated)}
                </Box>
              </StyledWhiteContainer>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
